import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';

export const procedureCopyRoute: RouteConfig = {
  path: 'copy',
  name: 'procedureCopy',
  component: () => import(/* webpackChunkName: "ProcedureCopy" */ '@/views/mainRoute/procedure/Copy.vue'),
  meta: {
    breadcrumb: { title: 'Tworzenie procedury na podstawie istniejącej' },
    config: {
      title: 'Tworzenie procedury na podstawie istniejącej',
      name: 'procedureCopy',
      icon: 'fa-clone',
      permissions: ['PROCEDURE.LIST', 'PROCEDURE.COPY']
    }
  },
  beforeEnter: (to, from, next) => {
    store
      .dispatch('procedure/list')
      .then(() => {
        next();
      })
      .catch(err => store.dispatch('notifyError', { title: Errors.PROCEDURE_CANNOT_LIST }));
  }
};
